import React from "react";
import i18n from "i18next";
import { withRouter } from "react-router-dom";

import { api } from "@/utils/api";
import LPMain from "@/react-components/LPMain";
import ConfirmButton from "@/react-components/Confirm/Button";
import ConfirmMain from "@/react-components/Confirm/Main";
import url from "@/utils/url";

class LPPrivacyPolicySection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contentList: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    Promise.all([
      api.agreement.getPublishPrivacyPolicy(),
      api.agreement.getPublishInquiry(),
    ])
      .then((result) => {
        this.setState({
          contentList: [result[0][0], result[1][0]],
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  back = () => {
    const {
      history: { replace },
    } = this.props;
    replace(url.lp);
  };

  render() {
    const { contentList } = this.state;
    return (
      <LPMain className="lp-privacy-policy-container">
        {contentList.length > 0 && (
          <div className="lp-privacy-policy-container-title">
            {contentList.reduce(
              (previous, current) =>
                `${previous.noLoginTitle}・${current.noLoginTitle}`
            )}
          </div>
        )}
        <div className="lp-privacy-policy-container-content">
          {contentList.map((item, index) => (
            <div
              className="lp-privacy-policy-container-content-item"
              key={index}
            >
              <div className="lp-privacy-policy-container-content-item-title">
                {item.noLoginTitle}
              </div>
              <ConfirmMain content={item.contentText} />
            </div>
          ))}
          <ConfirmButton
            onClick={this.back}
            text={i18n.t("common_back_home_button_title")}
          />
        </div>
      </LPMain>
    );
  }
}

export default withRouter(LPPrivacyPolicySection);
